export type WheelGestureMode = "pan" | "zoom" | "pending";

const GESTURE_GAP_MS = 90;
const DECIDE_PX = 4;

export interface WheelGestureState {
  dx: number;
  dy: number;
  at: number;
  mode: "pan" | "zoom" | null;
}

export function createWheelGestureState(): WheelGestureState {
  return { dx: 0, dy: 0, at: 0, mode: null };
}

/**
 * One two-finger gesture is either a sideways pan or a zoom, never both.
 * The first few pixels pick the axis, then the rest of the swipe stays there.
 */
export function wheelGestureMode(
  state: WheelGestureState,
  event: {
    ctrlKey: boolean;
    deltaX: number;
    deltaY: number;
    timeStamp: number;
  },
): WheelGestureMode {
  if (event.timeStamp - state.at > GESTURE_GAP_MS) {
    state.dx = 0;
    state.dy = 0;
    state.mode = null;
  }
  state.at = event.timeStamp;
  if (event.ctrlKey) {
    state.mode = "zoom";
    return "zoom";
  }
  state.dx += event.deltaX;
  state.dy += event.deltaY;
  const travel = Math.abs(state.dx) + Math.abs(state.dy);
  if (state.mode === null && travel >= DECIDE_PX) {
    state.mode = Math.abs(state.dx) > Math.abs(state.dy) ? "pan" : "zoom";
  }
  if (state.mode === null) {
    return "pending";
  }
  return state.mode;
}
